/**
 * View component for /metricCategoryCategories/new
 *
 * Creates a new metricCategory from a copy of the defaultItem in the metricCategory reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as metricCategoryActions from '../metricCategoryActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import metricCategory components
import MetricCategoryForm from '../components/MetricCategoryForm.js.jsx';
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';

class CreateMetricCategory extends Base {
  constructor(props) {
    super(props);
    this.state = {
      metricCategory: { ...this.props.defaultMetric }

      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newMetricState = _.update( this.state.metricCategory, e.target.name, function() {
      return e.target.value;
    });
    this.setState({metricCategory: newMetricState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(metricCategoryActions.sendCreateMetricCategory(this.state.metricCategory)).then((action) => {
      if(action.success) {
        dispatch(metricCategoryActions.invalidateList());
        history.push(`/admin/authoring/metric-categories/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { metricCategory } = this.state;
    const { location } = this.props;
    const isEmpty = (metricCategory.title === null || metricCategory.title === undefined);
    return (
      <AuthoringLayout>
        <Helmet
          title={"Create New Category | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
            </div>
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <MetricCategoryForm
                metricCategory={metricCategory}
                cancelLink="/admin/authoring/metric-categories"
                formTitle="Create Metric Category"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
    </AuthoringLayout>
    )
  }
}

CreateMetricCategory.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultMetric: store.metricCategory.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateMetricCategory)
);



// WEBPACK FOOTER //
// modules/metricCategory/views/CreateMetricCategory.js.jsx